import React from 'react';
import './FooterNav.css';
import '../../root.css';
import { Link } from 'react-router-dom';


const FooterNav = () => {
    return ( 
        <div className='FooterNav'>
            <p className='ColTitle'>Navigate</p>

            <ul className='FNavBtns'>
                <Link className='FNavBtn' to="/">Home</Link>
                <Link className='FNavBtn' to="/Catalogue">Listings</Link>
                <Link className='FNavBtn' to="/Details">Details</Link>
            </ul>
        </div>
     );
}
 
export default FooterNav;